
import React from "react";
import { Spin } from "antd";
import Config from "../config/Config";

let application = Config.getApplication();
let baseRoutePath = Config.getBaseRoutePath();
class tokenLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const encodedToken = urlParams.get('token');
    const signature = urlParams.get('sig');
    const link = urlParams.get('link');
    if (encodedToken && signature) {
      try {
        // 解码
        const accessToken = atob(encodedToken);
        const isValid = btoa(accessToken + application) === signature
        if (isValid) {
          sessionStorage.setItem("_user_access_", accessToken);
          window.history.replaceState({}, document.title, '/');
        } else {
          throw new Error('签名验证失败');
        }
      } catch (error) {
        console.error('授权过程出错:', error);
        window.location.href = '/login';
      }
    }
    if (link) {
      window.location.href = `${baseRoutePath}/home/${link}`;
    } else {
      window.location.href = `${baseRoutePath}/home/homepage`;

    }
  }

  componentWillUnmount() {

  }



  render() {
    let { } = this.state;
    return (
      <div style={{ height: '100vh', width: "100%",justifyContent:"center" }} >
        <Spin tip="正在登录..." spinning={false}>
        </Spin >
      </div >
    );
  }
}

export default tokenLogin;
